/**
 * Mapbox hash looks like `#zoom/lat/lng`. Start/end markers used to fall back
 * to 11.72 when the hash was missing, which yanked a street-level dashboard
 * map out to city scale after we stopped writing the hash.
 *
 * @param {string} [hash]
 * @param {number} fallbackZoom
 * @returns {number}
 */
function zoomFromMapHash (hash, fallbackZoom) {
  const text = hash ? String(hash).replace('#', '') : ''
  const parts = text.split('/')
  if (parts.length >= 3 && parts[0] !== '') {
    const parsed = Number(parts[0])
    if (parsed === parsed) {
      return parsed
    }
  }
  return fallbackZoom
}

export {
  zoomFromMapHash
}
